<template src="./Index.html"></template>

<script>
import { showAlert } from "@/utils/helpers";
import { HubConnectionBuilder, LogLevel } from "@aspnet/signalr";

export default {
  //props: {
  //  itemId: {
  //    type: Number,
  //    required: true,
  //  },
  //},   
  model: {
    prop: "employee",
  },
  props: ["employee"],
  created() {
    this.$store.dispatch("lookups/getSpecialties");
    this.$store.dispatch("lookups/getUniversities");
    this.HubConnect();

    //this.$store
    //  .dispatch("employeeQualifications/getForEdit", this.itemId)
    //  .then((res) => {
    //    this.employee = res;
    //  })
    //  .catch(() => {});
  },
  computed: {
    specialties() {
      return this.$store.state.lookups.specialties;
    },
    sourceTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.SourceTypes
      );
    },
    uploadTypes() {
      return [
        { value: 1, label: "عبر المسح الضوئي" },
        { value: 2, label: "تحميل المرفق من الجهاز" }
      ]
    },
    sources() {
      return this.$store.getters["lookups/getUniversityByType"](
        this.employeeQualification.sourceTypeId
      );
    },
  },
  data() {
    return {
      index: null,
      actionFlag: false,
      employeeQualifications: [],
      headers: [
        {
          text: "المؤهل العلمي",
          value: "qualificationDetailsName",
          sortable: false,
          align: "start",
        },
        {
          text: "التخصص",
          value: "specialty",
          sortable: false,
          align: "start",
        },
        {
          text: "تاريخ المؤهل",
          value: "qualificationDate",
          sortable: false,
          align: "start",
        },
        {
          text: "نوع مصدر المؤهل",
          value: "sourceType",
          sortable: false,
          align: "start",
        },

        {
          text: "مصدر  المؤهل",
          value: "source",
          sortable: false,
          align: "start",
        },
        //{
        //    text: "الوثيقة المرفقة",
        //    value: "fileName",
        //    sortable: false,
        //    align: "start",
        //},
        {
          text: "الإجراءات",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      employeeObj: { details: []},
      employeeQualification: {
        qualificationAttachment: null,
        fileName: null,
        byScanner: null,
        qualificationDate: null,
      },
    };
  },
  // mounted: function () {
  //   this.connection.start();
  //   this.connection.on("ReceiveMessage", (fileName) => {
  //     console.log(fileName);
  //     this.employeeQualification.fileName = fileName;
  //   });
  // },
  methods: {
    ChangeUploadTypes() {
      this.employeeQualification.attachmentFile = null;
      this.employeeQualification.fileName = null;
    },
    addInfo() {
      console.log(this.employeeQualification)
      let specialtyIndex = this.specialties.findIndex(
        (x) => x.value == this.employeeQualification.specialtyId
      );
      let sourceTypeIdex = this.sourceTypes.findIndex(
        (x) => x.value == this.employeeQualification.sourceTypeId
      );
      let sourceIndex = this.sources.findIndex(
        (x) => x.value == this.employeeQualification.sourceId
      );
      if (
        this.employeeQualification.qualificationAttachment != null &&
        this.employeeQualification.byScanner == 2 &&
        this.employeeQualification.qualificationAttachment.type !=
        "application/pdf" &&
        this.employeeQualification.qualificationAttachment.type !=
        "image/jpeg" &&
        this.employeeQualification.qualificationAttachment.type !=
        "image/jpg" &&
        this.employeeQualification.qualificationAttachment.type != "image/png"
      ) {
        showAlert("نوع المستند غير مدعوم يمكن رفع مستند pdf و صور فقط");
        return false;
      }
      this.employeeObj.details.push({
        qualificationDetailsName:
          this.employeeQualification.qualificationDetailsName,
        specialtyId: this.employeeQualification.specialtyId,
        sourceTypeId: this.employeeQualification.sourceTypeId,
        sourceId: this.employeeQualification.sourceId,
        qualificationDate: this.employeeQualification.qualificationDate,

        //file: this.employeeQualification.file,

        specialty: this.specialties[specialtyIndex].label,
        sourceType: this.sourceTypes[sourceTypeIdex].label,
        source: this.sources[sourceIndex].label,
        qualificationAttachment: this.employeeQualification.qualificationAttachment,
        fileName: this.employeeQualification.fileName,
        byScanner: this.employeeQualification.byScanner,
      });
      (this.employeeQualification = {
        qualificationDetailsId: 0,
        qualificationAttachment: null,
        fileName: null,
        byScanner: null,
      }),
        this.$refs.info.reset();

    }, cancel() {
      this.$emit("nextStep");
    },
    getInfoToEdit(index) {
      this.index = index;
      this.employeeQualification = this.employeeObj.details[index];
      this.actionFlag = true;
    },
    removeInfo(index) {
      this.employeeObj.details.splice(index, 1);
    },
    editInfo() {
      let specialtyIndex = this.specialties.findIndex(
        (x) => x.value == this.employeeQualification.specialtyId
      );
      let sourceTypeIdex = this.sourceTypes.findIndex(
        (x) => x.value == this.employeeQualification.sourceTypeId
      );
      let sourceIndex = this.sources.findIndex(
        (x) => x.value == this.employeeQualification.sourceId
      );

      //this.employeeQualification.qualificationAttachment = this.employeeQualification.file.name;

      (this.employeeQualification.specialty =
        this.specialties[specialtyIndex].label),
        (this.employeeQualification.sourceType =
          this.sourceTypes[sourceTypeIdex].label),
        (this.employeeQualification.source = this.sources[sourceIndex].label),
        this.employee.details.splice(this.index, 1, this.employeeQualification);
      (this.employeeQualification = {
        qualificationDetailsId: 0, qualificationAttachment: null,
        fileName: null,
        byScanner: null,
      }),
        this.$refs.info.reset();
      this.actionFlag = false;

    },
    confirm() {
      let payload = {
        employeeId: this.employee.employeeId,
        items: this.employeeObj.details,
      };

      this.$store
        .dispatch("employeeQualifications/edit", {
          id: this.employee.qualificationId,
          payload: payload,
        })
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
    allowedDates(val) {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 15);
      const date = new Date(val);
      return date < today;
    },
    back() {
      this.connection.stop();

      this.$emit("reload");
    },
    download(item) {
      window.open(
        `/api/employeeQualifications/${item.qualificationDetailsId}/attachment`,
        "_blank"
      );
    },
    scann() {
      var type = this.$attachmentTypes.QualificationFile;
      console.log(type);
      var p = "DisableScanner331://" + 1 + "-" + type;
      console.log(p);
      window.location.href = p;
      this.connection.on("ReceiveMessage", (fileName) => {
        console.log(fileName);
        this.employeeQualification.fileName = fileName;
      });

    },
    HubConnect() {
      this.connection = new HubConnectionBuilder()
        .withUrl("/ScanHub")
        .configureLogging(LogLevel.Information)
        .build();
      this.connection.start().catch(function (err) {
        return console.error(err.toSting());
      });
    },
  },
};
</script>